import { ExpirationThresholdConfig } from 'dashboard/models/verification-check-config/id-expiration-detection';
import { RequiredPropertyConfig } from 'dashboard/models/verification-check-config/id-extracted-properties-detection';
import { CountryCodeLower } from 'dashboard/models/verification-template-version';
import { GovernmentIdClass } from 'lib/constants/governmentIds';

// country overrides in FormSectionCountryConfigurations
export type CountryOverrideConfigs = RequiredPropertyConfig[] | ExpirationThresholdConfig[];

/**
 * returns index of override config (currently expiration or required properties),
 * given a country code and idclass
 */
export const indexForOverride = ({
  attributesField,
  countryCode,
  idClass,
}: {
  attributesField: CountryOverrideConfigs;
  countryCode: CountryCodeLower | 'default';
  idClass: GovernmentIdClass | 'default';
}): number => {
  return attributesField.findIndex(
    (config: RequiredPropertyConfig | ExpirationThresholdConfig) =>
      config['country-code'].toUpperCase() === countryCode.toUpperCase() &&
      (config['id-class'] || '').toLowerCase() === (idClass || '').toLowerCase(),
  );
};
